const initialState = {
  cacheEnabled: true,
};

const cache = (state = initialState, action) => {
  switch (action.type) {
    case 'CACHE_RESULT':
      return {
        ...state,
        ...action.cache,
      };

    case 'CACHE_ENABLE':
      return {
        ...state,
        cacheEnabled: !state.cacheEnabled,
      };

    default:
      return state;
  }
};

export default cache;

export const isCacheEnabled = (state) => state.cacheEnabled;
